import { getLocale } from "./i18n";

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public details?: any,
  ) {
    super(message);
  }
}

async function handle<T>(res: Response): Promise<T> {
  const text = await res.text();
  const body = text ? safeJson(text) : null;
  if (!res.ok) {
    const e = body?.error;
    throw new ApiError(res.status, e?.code ?? "error", e?.message ?? res.statusText, e?.details);
  }
  return body as T;
}

function safeJson(t: string) {
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}

/** Same-origin JSON API. The session cookie is HttpOnly; X-Requested-With satisfies the CSRF check. */
export async function api<T = any>(path: string, opts: { method?: string; body?: unknown; headers?: Record<string, string> } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method: opts.method ?? (opts.body !== undefined ? "POST" : "GET"),
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "walashy",
        "X-Locale": getLocale(),
        ...(opts.body !== undefined ? { "Content-Type": "application/json" } : {}),
        ...opts.headers,
      },
      body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    });
  } catch {
    throw new ApiError(0, "offline", getLocale() === "ar" ? "أنت غير متصل. تحقق من الاتصال وحاول مجدداً." : "You're offline. Check your connection and try again.");
  }
  return handle<T>(res);
}

export async function upload<T = any>(path: string, file: File | Blob): Promise<T> {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(path, { method: "POST", body: form, credentials: "same-origin", headers: { "X-Requested-With": "walashy", "X-Locale": getLocale() } });
  return handle<T>(res);
}
